import { createContext, useContext } from 'react';
export var ResponsiveContext = /*#__PURE__*/createContext(undefined);
export var useResponsiveContext = function useResponsiveContext() {
  var context = useContext(ResponsiveContext);
  if (context === undefined) {
    throw new Error('useResponsiveContext must be used within a ResponsiveProvider component');
  }
  return context;
};